import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import i18n from './VueI18n'

import SuggesterVue from'./suggester/suggester.vue'


class Suggester {
    constructor(appId) {
        Vue.use(VueAxios, axios)
        this.app = new Vue({
            el: appId,
            i18n,
            components: {
                findologicSuggester: SuggesterVue,
            }
        });
    }
}

export default Suggester;
